export const ReconcilationColumns = [
    {
        id: "Sr_no",
        width: "5%",
        position: "sticky",
        fontSize: "0.8em",
        padding: "0.4em",
        textAlign: "center",
        left: "0%",
        backgroundColor: "black",
        z: "1",
        color: "white",
        label: "SR NO",
    },
    {
        id: "Medicine PDF Name",
        width: "30%",
        position: "sticky",
        fontSize: "0.8em",
        padding: "0.4em",
        textAlign: "center",
        left: "10%",
        backgroundColor: "black",
        z: "1",
        color: "white",
        label: "MEDICINE NAME (Claim)",
    },
    {
        id: "Batch No.",
        width: "20%",
        position: "sticky",
        fontSize: "0.8em",
        padding: "0.4em",
        textAlign: "center",
        left: "10%",
        backgroundColor: "black",
        z: "1",
        color: "white",
        label: "BATCH NO. (Claim)",
    },
    {
        id: "quantity",
        width: "10%",
        position: "sticky",
        fontSize: "0.8em",
        padding: "0.4em",
        textAlign: "center",
        left: "10%",
        backgroundColor: "black",
        z: "1",
        color: "white",
        label: "QTY",
    },
    {
        id: "actions",
        width: "20%",
        position: "sticky",
        fontSize: "0.8em",
        padding: "0.4em",
        textAlign: "center",
        left: "10%",
        backgroundColor: "black",
        z: "1",
        color: "white",
        label: "ACTIONS",
    },
];
export const qty = [0, "0", '0.00', '-', "_", "", null, undefined]

// -- UPDATE reconcilation_pdfdata
// -- SET table_data = regexp_replace(table_data, 'BatchNo', 'batch_number', 'g');

// -- UPDATE reconcilation_pdfdata
// -- SET table_data = regexp_replace(table_data, 'Product Description', 'description', 'g');

// -- UPDATE reconcilation_pdfdata
// -- SET table_data = regexp_replace(table_data, 'Quantity', 'quantity', 'g');